import round from 'lodash/round';

// eslint-disable-next-line import/prefer-default-export
export const roundToPrecision = (num = 0, precision = 2) =>
  round(num, precision);
